import React, {ReactNode} from 'react'
import {SessionStorageHelper} from '../SessionStorageHelper'

interface Props {
    permittedAuthorities: string
    children: ReactNode
}

export default class AuthorityChecker extends React.Component<Props> {
    render(): ReactNode {
        const authorities: string[] = JSON.parse(SessionStorageHelper.getStringItemWithDefault('AUTHORITIES', '[]'))
        if (!authorities.includes(this.props.permittedAuthorities)) {
            // @ts-ignore
            return null
        }
        return this.props.children
    }
}
